import LiveModal from 'live/components/ui/Modal'
import styled from 'styled-components'

interface CustomButton {
    backgroundColor: string
    borderConfiguration: string
    textColor: string
    minSize?: string
}

export const LiveModalWrapper = styled(LiveModal)`
    .modal-dialog {
        width: 350px;
        height: 248px;
    }
    .modal-body {
        padding: 30px;
    }
`

export const ModalHeader = styled(LiveModal.Header)`
    min-height: 45px;
    height: unset;
`

export const ModalTitle = styled(LiveModal.Title)`
    line-height: 25px;
    min-height: 45px;
    padding: 10px 0;
    height: unset;
    display: flex;
    align-items: center;
    gap: 0.5em;
`

export const ModalBody = styled(LiveModal.Body)`
    min-height: 45px;
    height: unset;
    padding: 5px;
`

export const ModalFooter = styled(LiveModal.Footer)`
    min-height: 45px;
    height: unset;
    button {
        &:first-child {
            margin-right: 1.5rem;
        }
    }
`

export const CustomButton = styled.button<CustomButton>`
    width: fit-content;
    min-width: ${props => props.minSize};
    height: 30px;
    background: ${props => props.backgroundColor};
    color: ${props => props.textColor};
    border: ${props => props.borderConfiguration};
    border-radius: 4px;
    font-size: 12px;
`

export const ConfirmCustomButton = styled.button`
    width: fit-content;
    height: 30px;
    padding: 0 12px;

    border: none;
    border-radius: 4px;

    font-size: 13px;
    font-weight: 700;

    color: white;
    background: var(--brand-primary);
`

export const CancelCustomButton = styled.button`
    width: fit-content;
    height: 30px;
    padding: 0 12px;

    border: 1px solid var(--gray-300);
    border-radius: 4px;

    font-size: 13px;
    font-weight: 700;

    color: var(--gray-800);
    background: transparent;
`
